import { useEffect, useState } from 'react';

export function useMediaQuery(mediaQuery: string) {
  const [doesMatch, setDoesMatch] = useState(false);

  useEffect(() => {
    const query = window.matchMedia(mediaQuery);
    setDoesMatch(query.matches);

    const handleChange = () => setDoesMatch(query.matches);
    query.addEventListener('change', handleChange);

    return () => query.removeEventListener('change', handleChange);
  }, []);

  return doesMatch;
}
